import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout/Layout';

// Import images
import kidsClass from '../assets/kids_class.jpg';
import balletFeetInFifth from '../assets/ballet_feet_in_fifth.jpg';
import stageShoes from '../assets/stage_shoes.png';
import kidsWaitingToGetOnstage from '../assets/kids_waiting_to_get_onstage.jpg';
import waitingBeforeBalletCompetition from '../assets/waiting_before_ballet_competition.jpg';
import rihoPerformingSolo from '../assets/riho_performing_solo.png';

const Support = () => {
  return (
    <Layout
      title="Support Ballet Competition | Prix du Canada Toronto"
      description="Support Prix du Canada ballet competition in Toronto. Donate, sponsor, or volunteer to help make ballet accessible to all dancers including adult and recreational participants."
      keywords="support ballet competition Canada, ballet competition Toronto sponsorship, dance competition donations, volunteer ballet competition, support dance arts Canada"
    >
      {/* Elegant Hero Section */}
      <section className="elegant-hero">
        <div className="hero-background">
          <img src={kidsClass} alt="Young dancers in class" style={{opacity: 0.3}} />
        </div>
        <div className="container">
          <h1>Support the Future of Dance</h1>
          <p style={{textAlign: 'center'}}>Your support helps us keep our doors open to dancers of all backgrounds, ensuring that every participant can take the stage regardless of their financial circumstances. Join us in making dance accessible to everyone.</p>
        </div>
      </section>

      {/* Support Options Section */}
      <section className="support-section">
        <div className="container">
          <h2 style={{textAlign: 'center'}}>Ways to Support</h2>
          <p style={{textAlign: 'center', fontSize: '1.2rem', color: 'var(--soft-gray)', maxWidth: '700px', margin: '0 auto'}}>Every contribution, partnership, and volunteer hour helps us maintain our commitment to giving every dancer their moment on stage.</p>
          
          <div className="support-grid">
            <div className="support-card">
              <div style={{textAlign: 'center', marginBottom: '1.5rem'}}>
                <img src={balletFeetInFifth} alt="Supporting dancers" style={{width: '80px', height: '80px', borderRadius: '50%', objectFit: 'cover', margin: '0 auto', display: 'block'}} />
              </div>
              <h3>Donate</h3>
              <p>Every contribution helps us provide stage opportunities for dancers of all ages and backgrounds. Your generosity directly supports scholarships and keeps our competition accessible to everyone.</p>
              <p><Link to="/contact">Contact us</Link> to learn about donation opportunities and how your gift makes a difference.</p>
            </div>
            
            <div className="support-card">
              <div style={{textAlign: 'center', marginBottom: '1.5rem'}}>
                <img src={stageShoes} alt="Partnership opportunity" style={{width: '80px', height: '80px', borderRadius: '50%', objectFit: 'cover', margin: '0 auto', display: 'block'}} />
              </div>
              <h3>Corporate Sponsorship</h3>
              <p>Partner with us to support the arts and make a lasting impact in the dance community. Choose from four sponsorship tiers with benefits including logo placement, event recognition, VIP access, and more.</p>
              <p><Link to="/corporate-sponsorship">View sponsorship tiers</Link> or <a href="mailto:info@prixducanada.com">contact us</a> to explore custom partnership opportunities.</p>
            </div>
            
            <div className="support-card">
              <div style={{textAlign: 'center', marginBottom: '1.5rem'}}>
                <img src={kidsWaitingToGetOnstage} alt="Volunteer with dancers" style={{width: '80px', height: '80px', borderRadius: '50%', objectFit: 'cover', margin: '0 auto', display: 'block'}} />
              </div>
              <h3>Volunteer</h3>
              <p>Join our dedicated team backstage or front of house. Volunteering is a wonderful way to support the arts while being part of the magic that happens when dancers take the stage.</p>
              <p>Email <a href="mailto:info@prixducanada.com">info@prixducanada.com</a> to get involved and help create unforgettable experiences for our participants.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Impact Section */}
      <section className="section" style={{background: 'var(--light-gray)'}}>
        <div className="container">
          <h2 style={{textAlign: 'center'}}>Making an Impact</h2>
          <div style={{maxWidth: '800px', margin: '0 auto', textAlign: 'center'}}>
            <p style={{fontSize: '1.2rem', marginBottom: '3rem'}}>Your support directly contributes to creating a world where every dancer can experience the transformative power of live performance.</p>
            
            <div className="mission-vision">
              <div className="card">
                <div style={{textAlign: 'center', marginBottom: '1rem'}}>
                  <img src={waitingBeforeBalletCompetition} alt="Accessible dance" style={{width: '60px', height: '60px', borderRadius: '50%', objectFit: 'cover', margin: '0 auto', display: 'block'}} />
                </div>
                <h3>Accessibility</h3>
                <p style={{textAlign: 'center'}}>Scholarship programs and sliding scale fees ensure that financial barriers never prevent a dancer from taking our stage and sharing their artistry.</p>
              </div>
              <div className="card">
                <div style={{textAlign: 'center', marginBottom: '1rem'}}>
                  <img src={rihoPerformingSolo} alt="Excellence in dance" style={{width: '60px', height: '60px', borderRadius: '50%', objectFit: 'cover', margin: '0 auto', display: 'block'}} />
                </div>
                <h3>Excellence</h3>
                <p style={{textAlign: 'center'}}>Professional standards, high production values, and meaningful feedback create an environment where every performance is valued and celebrated.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Support; 